import { Component, Input } from '@angular/core';

@Component({
  selector: 'un-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  @Input() public logo: string = '';
  @Input() public logoDescription: string = '';
}
